import { RouterProvider } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { router } from './routes';
import ProvidersTree from '~/ProvidersTree';
import Smartlook from 'smartlook-client';
import { useEffect } from 'react';

const App = () => {
  useEffect(() => {
    try {
      console.log('Initializing Smartlook');
      Smartlook.init(import.meta.env.VITE_SMARTLOOK_ID, {
        advancedNetwork: {
          allowedUrls: [/.*/], // allowedHeaders: ["x-custom-header"],
        },
        region: 'eu',
      });
      Smartlook.record({ forms: true, numbers: true, emails: true, ips: true });
    } catch (error) {
      console.error('Error initializing Smartlook', error);
    }
  }, []);

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      }}
      cacheLocation="localstorage"
    >
      <ProvidersTree>
        <RouterProvider router={router} />
      </ProvidersTree>
    </Auth0Provider>
  );
};

export default App;
